// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgotpassword-container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 130px;
}
.resetpassword-container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 130px;
}
.forgot-password-h {
  color: #000;
  font-family: "Montserrat";
  font-size: var(--Font-Font-Size-h2, 23px);
  font-style: normal;
  font-weight: 700;
  text-align: center;
  line-height: 30px;
}
.forgot-password-sh {
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 14px);
  font-style: normal;
  font-weight: 500;
  width: 400px;
  line-height: 24px;
}
.reset-button {
  width: 100%;
  background-color: #d2042d;
  border: none;
  margin-top: 10px;
  font-weight: bold;
  height: 50px;
}
.try-span-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: var(--Colors-Text-500, #0a0f0d);
}
.try-span-text-row {
  margin-top: 1rem;
}
.please-check-text {
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.highlighted-email {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #0a0f0d;
  text-align: center;
}
@media only screen and (max-width: 1024px) {
  .forgotpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 190px;
  }
  .resetpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 190px;
  }
  .forgot-password-h {
    color: #000;
    font-family: "Montserrat";
    font-size: var(--Font-Font-Size-h2, 23px);
    font-style: normal;
    font-weight: 800;

    line-height: 30px;
  }
  .forgot-password-sh {
    color: #666;
    text-align: center;
    font-family: Roboto;
    font-size: var(--Font-Font-Size-p, 14px);
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
  .login-button {
    width: 100%;
    background-color: #d2042d;
    border: none;
    font-weight: 500;
    height: 40px !important;
  }
}

@media only screen and (max-width: 768px) {
  .forgotpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-left: 60px;
    padding-right: 70px;
    padding-top: 190px;
    margin-bottom: 40%;
  }
  .resetpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 190px;
    padding-left: 0px !important;
    padding-right: 0px !important;
    margin-bottom: 40%;
  }
  .forgot-password-h {
    color: #000;
    font-family: "Montserrat";
    font-size: var(--Font-Font-Size-h2, 23px);
    font-style: normal;
    font-weight: 800;

    line-height: 30px;
  }
  .forgot-password-sh {
    color: #666;
    text-align: center;
    width: 330px;
    font-family: Roboto;
    font-size: var(--Font-Font-Size-p, 14px);
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
  .login-button {
    width: 100%;
    background-color: #d2042d;
    border: none;
    font-weight: 500;
    height: 40px !important;
  }
  .reset-button {
    width: 100%;
    background-color: #d2042d;
    border: none;
    margin-top: 10px;
    font-weight: bold;
    height: 40px;
  }
}
@media only screen and (max-width: 740px) {
  .forgotpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 70px;
    margin-bottom: 40%;
  }
  .resetpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 70px;
    margin-bottom: 40%;
  }
  .reset-button {
    width: 100%;
    background-color: #d2042d;
    border: none;
    width: auto;
    margin-top: 10px;
    font-weight: bold;
    height: 50px;
  }
}
@media only screen and (max-width: 430px) {
  .forgotpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 70px;
    margin-bottom: 40%;
  }
  .resetpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding-top: 70px;
    margin-bottom: 40%;
  }
  .reset-button {
    width: 100%;
    background-color: #d2042d;
    border: none;
    margin-top: 10px;
    font-weight: bold;
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/LoginPage/forgotpassword/ForgotPassword.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;;IAEhB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;;IAEhB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;AACF","sourcesContent":[".forgotpassword-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding-top: 130px;\n}\n.resetpassword-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding-top: 130px;\n}\n.forgot-password-h {\n  color: #000;\n  font-family: \"Montserrat\";\n  font-size: var(--Font-Font-Size-h2, 23px);\n  font-style: normal;\n  font-weight: 700;\n  text-align: center;\n  line-height: 30px;\n}\n.forgot-password-sh {\n  color: #666;\n  text-align: center;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 14px);\n  font-style: normal;\n  font-weight: 500;\n  width: 400px;\n  line-height: 24px;\n}\n.reset-button {\n  width: 100%;\n  background-color: #d2042d;\n  border: none;\n  margin-top: 10px;\n  font-weight: bold;\n  height: 50px;\n}\n.try-span-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: var(--Colors-Text-500, #0a0f0d);\n}\n.try-span-text-row {\n  margin-top: 1rem;\n}\n.please-check-text {\n  color: #666;\n  text-align: center;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n.highlighted-email {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #0a0f0d;\n  text-align: center;\n}\n@media only screen and (max-width: 1024px) {\n  .forgotpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding-top: 190px;\n  }\n  .resetpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding-top: 190px;\n  }\n  .forgot-password-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-size: var(--Font-Font-Size-h2, 23px);\n    font-style: normal;\n    font-weight: 800;\n\n    line-height: 30px;\n  }\n  .forgot-password-sh {\n    color: #666;\n    text-align: center;\n    font-family: Roboto;\n    font-size: var(--Font-Font-Size-p, 14px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n  }\n  .login-button {\n    width: 100%;\n    background-color: #d2042d;\n    border: none;\n    font-weight: 500;\n    height: 40px !important;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .forgotpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding-left: 60px;\n    padding-right: 70px;\n    padding-top: 190px;\n    margin-bottom: 40%;\n  }\n  .resetpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding-top: 190px;\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n    margin-bottom: 40%;\n  }\n  .forgot-password-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-size: var(--Font-Font-Size-h2, 23px);\n    font-style: normal;\n    font-weight: 800;\n\n    line-height: 30px;\n  }\n  .forgot-password-sh {\n    color: #666;\n    text-align: center;\n    width: 330px;\n    font-family: Roboto;\n    font-size: var(--Font-Font-Size-p, 14px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n  }\n  .login-button {\n    width: 100%;\n    background-color: #d2042d;\n    border: none;\n    font-weight: 500;\n    height: 40px !important;\n  }\n  .reset-button {\n    width: 100%;\n    background-color: #d2042d;\n    border: none;\n    margin-top: 10px;\n    font-weight: bold;\n    height: 40px;\n  }\n}\n@media only screen and (max-width: 740px) {\n  .forgotpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding-top: 70px;\n    margin-bottom: 40%;\n  }\n  .resetpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding-top: 70px;\n    margin-bottom: 40%;\n  }\n  .reset-button {\n    width: 100%;\n    background-color: #d2042d;\n    border: none;\n    width: auto;\n    margin-top: 10px;\n    font-weight: bold;\n    height: 50px;\n  }\n}\n@media only screen and (max-width: 430px) {\n  .forgotpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding-top: 70px;\n    margin-bottom: 40%;\n  }\n  .resetpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding-top: 70px;\n    margin-bottom: 40%;\n  }\n  .reset-button {\n    width: 100%;\n    background-color: #d2042d;\n    border: none;\n    margin-top: 10px;\n    font-weight: bold;\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
